import { useEffect, useRef } from 'react';

export default function useClickOutside(callback, excludesClass) {
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      const currentRef = ref.current;

      const hasExludedClass =
        excludesClass &&
        event.target.className &&
        event.target.className.includes &&
        event.target.className.includes(excludesClass);

      if (
        currentRef &&
        !currentRef.contains(event.target) &&
        !hasExludedClass
      ) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);

  return ref;
}
